import { useState } from 'react';

// import { toasts } from '../../ui-component';

import LoginScreen from './components/LoginScreen';
import OTPScreen from './components/OTPScreen';

import { Container } from './style';

const Login = () => {
  const [screenType, setScreenType] = useState<'enterMoblie' | 'enterOTP'>('enterMoblie');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [dialCode, setDialCode] = useState<string>('+91');

  return (
    <Container>
      {screenType === 'enterMoblie' && (
        <LoginScreen
          phoneNumber={phoneNumber}
          dialCode={dialCode}
          setPhoneNumber={setPhoneNumber}
          setDialCode={setDialCode}
          setScreenType={setScreenType}
        />
      )}
      {screenType === 'enterOTP' && (
        <OTPScreen phoneNumber={phoneNumber} dialCode={dialCode} setScreenType={setScreenType} />
      )}
    </Container>
  );
};

export default Login;
